import(/* webpackMode: "eager" */ "/app/src/app/(site)/tin-tuc/page.tsx");
